import { copyApiPrefilterPerRole } from "@shared/backend/entity-security/copy-api-prefilter-per-role";
import type { HyperEntityConfig } from "@shared/backend/hyper-entity.decorator";
import { Roles } from "@shared/Roles";
import { Allow, remult } from "remult";
import { User } from "../user/entity";
import { type UserAvailability } from "./entity";

export const UserAvailabilityEntityConfig: HyperEntityConfig<UserAvailability> =
{
  allowApiRead: Allow.authenticated,
  allowApiCrud: Allow.authenticated,
  apiPrefilterPerRole: async (filter) => {
    filter(Roles.All, {
      user: {
        $is: await copyApiPrefilterPerRole(User),
      },
    });
  },

  allowInsertPerRole(allow) {
    allow(Roles.User, (entity) => entity.userId === remult.user!.id);
  },

  allowDeleteAndUpdatePerRole(allow) {
    allow(Roles.User, (entity) => entity.userId === remult.user!.id);
  },

  id: {
    userId: true,
    dow: true,
  },
};
